module.exports = __webpack_public_path__ + "img/about-market.f06a0b0.png";